import { SEARCH } from '@/queries';
import { availableFirst, withSearchLoading } from '~/lib/search';

// Find and attach the active parking schedule to each search result
const attachActiveSchedules = (searchResults) => {
  if (!searchResults) return [];
  
  return searchResults.map(result => {
    const activeSchedule = result.applicableSchedule
      ? result.lot?.parkingSchedules?.find(schedule => schedule.id === result.applicableSchedule)
      : null;
    
    return {
      ...result,
      activeSchedule
    };
  });
};

export const useSearchByCollection = async (collectionId, checkInDate, checkOutDate) => {
  const facilitySearch = useFacilitySearch();
  const searchStore = useSearchStore();

  const reservationTypes = searchStore.isOvernight ? ['OVERNIGHT'] : ['DAILY', 'HOURLY'];

  try {
    const { data } = await withSearchLoading(facilitySearch, () => useGraphQL(
      SEARCH,
      useTokens().access,
      {
        checkinDate: checkInDate || '',
        checkoutDate: checkOutDate || '',
        collection: collectionId && collectionId !== 'all' ? collectionId : null,
        reservationTypes: reservationTypes
      }
    ));

    const resultsWithSchedules = attachActiveSchedules(data?.value?.data?.search);
    facilitySearch.setSearchResults(availableFirst(resultsWithSchedules));

    return {
      isLoading: false,
      error: null,
      results: resultsWithSchedules
    }
  } catch (error) {
    console.error('Error Getting Codes:', error);
  }
}
